<template>
    <div class="side-menu-card app" v-if="isShow" @click="show=!show">
        <span>app</span>
        <div class="app-menu">
        </div>
        <!-- <v-dialog
        v-model="show"
        content-class="app-dialog"
        >
            <img :src="appImg"/>
        </v-dialog> -->
        <div class="app-dialog" :class="show?'open':'close'">
            <img :src="appImg"/>
        </div> 
        <div id="zhezhao" v-if="show"></div>
    </div>
</template>
<script>
import appImg from '../assets/img/common/sidemenu/app-flow2.png' // 引入所需图片
import { isFirstShowPoster } from '@/api/user'

export default {
    data:()=>({
        isShow: true,
        show: false,
        appImg: appImg
    }),
    mounted(){
       // this.show=true
        this.isFirstShowPoster()
    },
    methods: {
        isFirstShowPoster(){
            isFirstShowPoster().then(res => {
                if(res){
                    this.show= true
                }else{
                    this.show= false
                }
            })
        }
    }
}
</script>
<style>
.app-dialog{
    width:456px;
    height:566px;
    position:absolute;
    left:-216px;
    bottom:-266px;
    z-index:301;
    padding:20px;
    background:#fff;
    box-shadow: 0px 0px 7px rgba(125, 162, 255, 0.3);
    border-radius: 8px;
    transform:scale(0);
    transition: all 1s;
}
#zhezhao{
    background-color:#666;
    position:fixed;
    z-index:300;
    left:0;
    bottom:0;
    width:100vw;
    height:100vh;
    opacity:0.5;
}
.open{
    bottom:calc(50vh - 480px);
    transform:scale(1);
    left:calc(50vw - 228px);
}
.close{
    bottom:-266px;
    transform:scale(0);
    left:-216px;
}

</style>